import {
  EmptyState,
  Loading,
  MaterialIcon,
  StyledButton,
  StyledSearchBar,
  useDebouncedSearch,
} from '@gorila-shared-ui/components';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { SMALL_LIST_ITEM_HEIGHT } from '../../constants/app';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import {
  loadingPlacesState,
  placeIdsState,
  placesPageState,
  placesState,
  searchPlaceState,
  selectedPlaceIdState,
} from '../../storage/places';
import { Place } from '../../types/place';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { VirtualizedPaginatedList } from '../shared/VirtualizedPaginatedList';
import PlaceItem from './PlaceItem';

export function PlaceList() {
  const { theme } = useStyles();
  const placeIds = useRecoilValue(placeIdsState);
  const setSelectedPlaceId = useSetRecoilState(selectedPlaceIdState);
  const resetSelectedPlaceId = useResetRecoilState(selectedPlaceIdState);
  const loadingPlaces = useRecoilValue(loadingPlacesState);
  const { search, setSearch } = useDebouncedSearch(useRecoilState(searchPlaceState));
  const paginatedPlaces = useRecoilValue(placesState);
  const setPlacesPage = useSetRecoilState(placesPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedPlaceId();
    };
  });

  const onNewPlace = () => {
    setSelectedPlaceId('');
  };

  return (
    <FloatingCardContent
      flexible
      gap={theme.sizing.scale600}
    >
      {!placeIds && !loadingPlaces && <EmptyState title="Todavía no creas ningun lugar" />}
      {!placeIds && loadingPlaces && <Loading />}
      {placeIds && (
        <>
          <StyledSearchBar
            name="place-search"
            value={search}
            onChange={setSearch}
            clearable
            noMargin
          />
          <VirtualizedPaginatedList<Place>
            ids={placeIds}
            loading={loadingPlaces}
            onNextPage={setPlacesPage}
            paginatedResponse={paginatedPlaces}
            itemComponent={PlaceItem}
            itemSize={SMALL_LIST_ITEM_HEIGHT}
          />
          {!placeIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
      {(placeIds || !loadingPlaces) && (
        <StyledButton
          size="compact"
          shape="square"
          onClick={onNewPlace}
          startEnhancer={<MaterialIcon name={'add'} />}
          kind="tertiary"
        >
          Nuevo lugar
        </StyledButton>
      )}
    </FloatingCardContent>
  );
}
